import { Capacitor } from '@capacitor/core';
import { ExternalReturnValue } from 'src/app/@core/types';
import { SplashScreen } from '@capacitor/splash-screen';

export function HideSplash(callback: string = 'ionViewDidEnter'): ClassDecorator {
  return (c: ExternalReturnValue): void => {
    const ionViewDidEnter = c.prototype[callback];

    // eslint-disable-next-line func-names
    c.prototype[callback] = function (...args: ExternalReturnValue[]): void {
      document.body.classList.add('page-ready');
      // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
      ionViewDidEnter && ionViewDidEnter.apply(this, args);

      requestAnimationFrame(() => {
        if (Capacitor.isNativePlatform()) {
          SplashScreen.hide().catch();
        }
      });
    };
  };
}
